/**
 * Асинхронная блокировка для обеспечения потокобезопасности
 */
export class AsyncLock {
  private _queue: Array<() => void> = [];
  private _locked: boolean = false;

  /**
   * Получить блокировку
   */
  async acquire(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (!this._locked) {
        this._locked = true;
        resolve();
      } else {
        this._queue.push(resolve);
      }
    });
  }

  /**
   * Освободить блокировку
   */
  release(): void {
    if (!this._locked) {
      throw new Error('Cannot release an unlocked lock');
    }

    const next = this._queue.shift();
    if (next) {
      next();
    } else {
      this._locked = false;
    }
  }

  /**
   * Проверить заблокирована ли блокировка
   */
  isLocked(): boolean {
    return this._locked;
  }

  /**
   * Выполнить функцию с блокировкой
   */
  async withLock<T>(fn: () => T | Promise<T>): Promise<T> {
    await this.acquire();
    try {
      return await fn();
    } finally {
      this.release();
    }
  }
} 